<div class="nfd-card">
  <span class="nfd-title">Filter</span>
  <ul class="nfd-list">
    @for (opt of options; track opt.value) {
    <li class="nfd-option" [class.nfd-option--active]="activeFilter === opt.value" role="button" tabindex="0"
      (click)="select(opt.value)" (keydown.enter)="select(opt.value)"
      (keydown.space)="$event.preventDefault(); select(opt.value)">
      <span class="nfd-check">
        @if (activeFilter === opt.value) {
        <lucide-icon name="check" [size]="13" style="display: flex;"></lucide-icon>
        }
      </span>
      <lucide-icon class="nfd-icon" [name]="opt.icon" [size]="15" style="display: flex;"></lucide-icon>
      <span class="nfd-label">{{ opt.label }}</span>
    </li>
    }
  </ul>
</div>
